import http from './http';
import { UpdateRecordDto } from '../modules/customer/dto/update-record.dto';

export function update(recordId: string, dto: UpdateRecordDto) {
  if (
    dto.stockholders.length > 0 &&
    dto.stockholders.filter((stockholder) => stockholder.isMain).length === 0
  ) {
    dto.stockholders[0].isMain = true;
  }

  return http.put(`/api/customer/${recordId}`, dto);
}
